// extracted by mini-css-extract-plugin
export default {"equippedAddButton":"_2XnIq"};